
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import lib from './biz/lib';
import { MainLayout } from './components/Layout';
import { useSelector } from 'react-redux';

const LoginPage = React.lazy(() => import('./pages/loginPage'));
const SecurePurchasePage = React.lazy(() => import('./pages/securePurchasePage'));
const SecurePurchaseForm = React.lazy(() => import('./forms/securePurchaseForm'));
const SecureRentPage = React.lazy(() => import('./pages/secureRentPage'));
const SecureRentForm = React.lazy(() => import('./forms/secureRentForm'));
const PurchaseCumReceiptPage = React.lazy(() => import('./pages/purchaseCumReceiptPage'));
const PurchaseCumReceiptForm = React.lazy(() => import('./forms/purchaseCumReceiptForm'));
const UploadSlipChequeForm = React.lazy(() => import('./forms/uploadSlipChequeForm'));
const RentCumReceiptPage = React.lazy(() => import('./pages/rentCumReceiptPage'));
const RentCumReceiptForm = React.lazy(() => import('./forms/rentCumReceiptForm'));
const ClaimSubmissionPage = React.lazy(() => import('./pages/claimSubmissionPage'));
const ClaimSubmissionForm = React.lazy(() => import('./forms/claimSubmissionForm'));
const InvoicePage = React.lazy(() => import('./pages/invoicePage'));
const InvoiceRequestPage = React.lazy(() => import('./pages/invoiceRequestPage'));
const InvoiceRequestHistoryPage = React.lazy(() => import('./pages/invoiceRequestHistoryPage'));
const NotFoundPage = React.lazy(() => import('./pages/notFoundPage'));
const SingleSignOnPage = React.lazy(() => import('./pages/singleSignOnPage'));
const ReceiptPage = React.lazy(() => import('./pages/receiptPage'));
const ReceiptRequestPage = React.lazy(() => import('./pages/receiptRequestPage'));
const ReceiptRequestHistoryPage = React.lazy(() => import('./pages/receiptRequestHistoryPage'));
const DeveloperSalesPage = React.lazy(() => import('./pages/developerSalesPage'));
const DeveloperSalesForm = React.lazy(() => import('./forms/developerSalesForm'));
const OrderListingPage = React.lazy(() => import('./pages/orderListingPage'));
const MemoPage = React.lazy(() => import('./pages/memoPage'));
const CompanyLetterPage = React.lazy(() => import('./pages/companyLetterPage'));
const AnalyticPage = React.lazy(() => import('./pages/analyticPage'));
const CP58ListingPage = React.lazy(() => import('./pages/cp58ListingPage'));
const PaymentVoucherPage = React.lazy(() => import('./pages/paymentVoucherPage'));
const UserProfilePage = React.lazy(() => import('./pages/userProfilePage'));
const ResetPasswordPage = React.lazy(() => import('./pages/resetPasswordPage'));
const EmploymentApplicationPage = React.lazy(() => import('./pages/employmentApplicationPage'));
const EmploymentApplicationForm = React.lazy(() => import('./forms/employmentApplicationForm'));
const EmploymentAttachmentPage = React.lazy(() => import('./pages/employmentAttachmentPage'));
const UploadEmploymentAttachment = React.lazy(() => import('./forms/uploadEmploymentAttachment'));
const UploadDeveloperAttachment = React.lazy(() => import('./forms/uploadDeveloperAttachment'));
const AgentProfileImagePage = React.lazy(() => import('./pages/agentProfileImagePage'));

const App = () => {
  const loggedInAgent = useSelector(state => state.agent)

  const isLoggedIn = () => {
    lib.log('check logged in ..');
    if (loggedInAgent?._id) {
      lib.log(`loggedIn: true`);
      lib.log(loggedInAgent);
      return true;
    } else return false;
  };

  return (
    <>
      <Router>
        <Switch>
          {process.env.REACT_APP_IS_PRODUCTION === "false" ? <Route exact path="/" component={LoginPage} /> : <Route exact path="/" component={NotFoundPage} />}
          <Route exact path="/signon/:key/:page" component={SingleSignOnPage} />
          <Route exact path="/signon/:platform/:key/:page" component={SingleSignOnPage} />
          <Route exact path="/agent/:id/uploadProfileImage" sensitive component={AgentProfileImagePage} />
          {isLoggedIn() ?
            <MainLayout>
              <React.Suspense fallback={"Loading..."}>
                <Switch>
                  {process.env.REACT_APP_IS_PRODUCTION === "false" ? <>
                    <Route exact path="/securePurchaseForm" sensitive component={SecurePurchasePage} />
                    <Route exact path="/securePurchaseForm/edit" sensitive component={SecurePurchaseForm} />
                    <Route exact path="/secureRentForm" sensitive component={SecureRentPage} />
                    <Route exact path="/secureRentForm/edit" sensitive component={SecureRentForm} />
                    <Route exact path="/store/orderListing" sensitive component={OrderListingPage} />
                    <Route exact path="/memoListing" sensitive component={MemoPage} />
                    <Route exact path="/letterListing" sensitive component={CompanyLetterPage} />
                    <Route exact path="/changePassword" component={ResetPasswordPage} />
                    <Route exact path="/purchaseCumReceiptForm" sensitive component={PurchaseCumReceiptPage} />
                    <Route exact path="/purchaseCumReceiptForm/edit" sensitive component={PurchaseCumReceiptForm} />
                    <Route exact path="/rentCumReceiptForm" sensitive component={RentCumReceiptPage} />
                    <Route exact path="/rentCumReceiptForm/edit" sensitive component={RentCumReceiptForm} />
                    <Route exact path="/:formType/uploadSlipCheque" sensitive component={UploadSlipChequeForm} />
                    <Route exact path="/claims/claimsListing" sensitive component={ClaimSubmissionPage} />
                    <Route exact path="/claims/claimsCreate" sensitive component={ClaimSubmissionForm} />
                    <Route exact path="/invoice/invoiceListing" sensitive component={InvoicePage} />
                    <Route exact path="/invoiceRequest/invoiceRequestListing" sensitive component={InvoiceRequestPage} />
                    <Route exact path="/invoiceRequestHistory" sensitive component={InvoiceRequestHistoryPage} />
                    <Route exact path="/receipt/receiptListing" sensitive component={ReceiptPage} />
                    <Route exact path="/receiptRequest/receiptRequestListing" sensitive component={ReceiptRequestPage} />
                    <Route exact path="/receiptRequestHistory" sensitive component={ReceiptRequestHistoryPage} />
                    <Route exact path="/developerSalesForm" sensitive component={DeveloperSalesPage} />
                    <Route exact path="/developerSalesForm/edit" sensitive component={DeveloperSalesForm} />
                    <Route exact path="/developerSales/uploadAttachment" sensitive component={UploadDeveloperAttachment} />
                    <Route exact path="/analytics" sensitive component={AnalyticPage} />
                    <Route exact path="/myPV/myPVListing" sensitive component={PaymentVoucherPage} />
                    <Route exact path="/myUserProfile" sensitive component={UserProfilePage} />
                    <Route exact path="/cp58/cp58Listing" sensitive component={CP58ListingPage} />
                    <Route exact path="/employment/employmentListing" sensitive component={EmploymentApplicationPage} />
                    <Route exact path="/employment/addNewEmployment" sensitive component={EmploymentApplicationForm} />
                    <Route exact path="/employment/uploadAttachment" sensitive component={UploadEmploymentAttachment} />
                    <Route exact path="/employment/employmentAttachmentListing" sensitive component={EmploymentAttachmentPage} />
                  </> : <>
                    <Route exact path="/securePurchaseForm" sensitive component={SecurePurchasePage} />
                    <Route exact path="/securePurchaseForm/edit" sensitive component={SecurePurchaseForm} />
                    <Route exact path="/secureRentForm" sensitive component={SecureRentPage} />
                    <Route exact path="/secureRentForm/edit" sensitive component={SecureRentForm} />
                    <Route exact path="/store/orderListing" sensitive component={OrderListingPage} />
                    <Route exact path="/memoListing" sensitive component={MemoPage} />
                    <Route exact path="/letterListing" sensitive component={CompanyLetterPage} />
                    <Route exact path="/changePassword" component={ResetPasswordPage} />
                  </>}
                  <Route component={NotFoundPage} />
                </Switch>
              </React.Suspense>
            </MainLayout> :
            <Redirect to="/" />
          }
        </Switch>
      </Router>
    </>
  );
}

export default App;
